export default __webpack_public_path__ + "static/media/leftArrow.24d760f4.svg";